class YoursizeEnableController {
    /*@ngInject*/
    constructor($log, $rootScope, CommonService, YoursizeService, InfoBoxService) {
        $log.debug('YoursizeEnableController initialized');
        this.$log = $log;
        this.commonService = CommonService;
        this.yoursizeService = YoursizeService;
        this.infoBoxService = InfoBoxService;
        this.avatar = {};
        this.match = null;
        this.showNotLoggedInMsg = false;
        this.showNoFootScanMsg = false;
        this.hide = true;
        this.$rootScope = $rootScope;

        this.$rootScope.$on('personalizeRequestSuccess', () => {
            this.hide = false;
        });

        this.$rootScope.$on('yourSizeNotLoggedInInfoBoxVisible', () => {
            this.showNotLoggedInMsg = false;
        });

        this.$rootScope.$on('fetchAvatarsDone', () => {
            this.avatar = this.yoursizeService.getSelectedAvatar();
            if (this.avatar != {}) {
                this.match = this.avatar.match;
            }
        });
    }

    init(productCode) {
        this.yoursizeService.setProductCode(productCode);
    }

    isHidden() {
        return this.hide;
    }

    isEnabled() {
        return this.yoursizeService.isEnabled();
    }

    isLoggedIn() {
        return this.yoursizeService.isLoggedIn();
    }

    setState(targetState) {
        if (!this.isLoggedIn()) {
            this.infoBoxService.showYourSizeNotLoggedInInfoBox();
            this.showNotLoggedInMsg = true;
            return;
        }
        if (this.yoursizeService.isFootScanMissing()) {
            this.showNoFootScanMsg = true;
            return;
        }
        this.yoursizeService.setState(targetState);
    }

    hasMatchSize() {
        if (this.match === null) {
            return false;
        }
        else {
            try {
                return (this.avatar.match.size && this.avatar.match.size.length !== 0);
            }
            catch (e) {
                return false;
            }
        }
    }

}

export default YoursizeEnableController;
